import "./primaryBeneficiary.css";
import { Grid } from "@material-ui/core";
import GliGrid from "../gliGrid/GliGrid";
import { PrimaryBeneficiaeryProps } from "../../../../../../../../../@types/components/gliFormProps.types";

// eslint-disable-next-line react/prop-types
const PrimaryBeneficary = ({ isPrintable, primaryBeneficery }: PrimaryBeneficiaeryProps) => {
	return (
		<>
			<div className={isPrintable ? "gli-beneficiary-header-print" : "gli-beneficiary-header"}>
				PRIMARY BENEFICIARY(IES)
			</div>
			<div className={isPrintable ? "gli-beneficary-container-print" : "gli-beneficary-container"}>
				<Grid container spacing={1}>
					<Grid item xs={4} sm={4} md={4} lg={4} xl={4} className="gli-grid-header">
						<div className={isPrintable ? "gli-header-label font-size-small" : "gli-header-label"}>
							Primary Beneficiary’s Name and Address
						</div>
					</Grid>
					<Grid item xs={2} sm={2} md={2} lg={2} xl={2} className="gli-grid-header2">
						<div className={isPrintable ? "gli-header-label1 font-size-small" : "gli-header-label1"}>
							Social Security <br></br>Number
						</div>
					</Grid>
					<Grid item xs={2} sm={2} md={2} lg={2} xl={2} className="gli-grid-header3">
						<div className={isPrintable ? "gli-header-label1 font-size-small" : "gli-header-label1"}>
							Relationship<br></br> To You
						</div>
					</Grid>
					<Grid item xs={2} sm={2} md={2} lg={2} xl={2} className="gli-grid-header4">
						<div className={isPrintable ? "gli-header-label1 font-size-small" : "gli-header-label1"}>
							Date of Birth
						</div>
					</Grid>
					<Grid item xs={2} sm={2} md={2} lg={2} xl={2} className="gli-grid-header5">
						<div className={isPrintable ? "gli-header-label1 font-size-small" : "gli-header-label1"}>
							<p>
								Percentage:<br></br>Must equal 100%
							</p>
						</div>
					</Grid>
				</Grid>

				{primaryBeneficery ? <GliGrid isPrintable={isPrintable} eachBeneficery={primaryBeneficery[0]} /> : null}
				{primaryBeneficery ? <GliGrid isPrintable={isPrintable} eachBeneficery={primaryBeneficery[1]} /> : null}
				{primaryBeneficery ? <GliGrid isPrintable={isPrintable} eachBeneficery={primaryBeneficery[2]} /> : null}
			</div>
		</>
	);
};

export default PrimaryBeneficary;
